import React from 'react'
import styled from 'styled-components';
import { get } from 'lodash'
import { Image } from 'semantic-ui-react'

const Name = styled.div`
  line-height: 42px;
  display: block;
  font-size: 18px;
`;

const SummaryContainer = styled.div`
  margin-bottom: 22px;
`;

const Instructions = styled.div`
  color: #868686;
`;

const DetailedPaymentMethodSummary = ({paymentMethod, image, name}) => {
  if (image) {
    return (
      <SummaryContainer>
        <Image style={{height: 42}} verticalAlign='middle' src={image}/>
        {paymentMethod.instructions ?
          <Instructions>{paymentMethod.instructions} </Instructions> : null
        }
      </SummaryContainer>
    )
  } else if (name) {
    return (
      <SummaryContainer>
        <Name>{name}</Name>
        {paymentMethod.instructions ?
          <Instructions>{paymentMethod.instructions} </Instructions> : null
        }
      </SummaryContainer>
    )
  }
}


export default class PaymentMethodSummary extends React.PureComponent {

  getActivePaymentMethod = () => {
    const { cart, paymentMethods } = this.props;

    console.log(paymentMethods, cart.payment_method);

    return paymentMethods[cart.payment_method];
  };

  render() {
    const { cart, paymentMethods } = this.props;

    if(cart && paymentMethods) {
      const paymentMethod = this.getActivePaymentMethod();
      if(paymentMethod) {
        if(paymentMethod.type === 'ShopMaksekeskusMethod') {
          const image = get(cart, 'payment_method_arguments.logo_url');
          const name = get(cart, 'payment_method_arguments.name');

          return (
            <DetailedPaymentMethodSummary
              paymentMethod={ paymentMethod }
              image={ image }
              name={ name }
            />
          )
        } else if(['ShopPayseraMethod', 'ShopGratifyMethod'].indexOf(paymentMethod.type) > -1) {
          const image = get(cart, 'payment_method_arguments.logo_url');
          const name = get(cart, 'payment_method_arguments.title');

          return (
            <DetailedPaymentMethodSummary
              paymentMethod={ paymentMethod }
              image={ image }
              name={ name }
            />
          )
        }

        return (
          <SummaryContainer>
            <Name>{ paymentMethod.name }</Name>
            { paymentMethod.instructions ?
              <Instructions>{ paymentMethod.instructions } </Instructions> : null
            }
          </SummaryContainer>
        )

      }
    }

    return null;
  }
}
